import React from 'react';
import {Link, Route, Redirect} from 'react-router-dom';
import {Table, Tabs, Button, Spin, Input, Row, Col, Divider, Breadcrumb, Menu, Icon, Dropdown} from 'antd';
import monitorService from "../services/monitor.service";
import fileDownloadService from "../services/file.download.service";
import ActivityPublicContainer from "./ActivityPublicContainer.js";
import Toolbar from '../commons/Toolbar';
import _ from 'lodash'

const {TabPane} = Tabs;
const {Search} = Input;

const docTarget = (value, record, index) => {
    const folderPath = _.get(record, "detail.folderPath");
    const folderName = _.get(record, "detail.folderName", '');
    if (record && record.detail) {
        let msg = '';
        if (record.action === "upload") {
            const fileOrigName = _.get(record, "detail.files[0].originalname", '');
            msg = folderPath ? folderPath + "/" + fileOrigName : folderName+ "/" + fileOrigName
        }
        if (record.action === "delete" && ( ["docFiles", "photoFiles"].includes(record.module))) {
            const fileOrigName = _.get(record, "detail.file.originalname", '');
            msg = folderPath ? folderPath + "/" + fileOrigName : fileOrigName;
        }
        if (record.action === "delete" && (["docFolders", "photoFolders", "mapFolders", "videoFolders"].includes(record.module))) {
            msg = folderPath ? folderPath : folderName;
        }
        if (record.action === "create" && (["docFolders", "photoFolders", "mapFolders", "videoFolders"].includes(record.module))) {
            msg = folderPath ? folderPath + "/" + folderName : folderName;
        }
        if (record.action === "rename" && (["docFolders", "photoFolders", "mapFolders", "videoFolders"].includes(record.module))) {
            msg = folderPath ? folderPath : folderName;
        }
        if (record.action === "share" && ["photoFolders", "videoFolders"].includes(record.module)) {
            msg = folderPath ? folderPath : _.get(record, 'detail.folder.text', '');
        }
        if (record.action === "share" && record.module === "docFiles") {
            const fileOrigName = _.get(record, "detail.file.originalname", '');
            msg = folderPath ? folderPath + "/" + fileOrigName : fileOrigName;
        }
        if (record.action === "download" && (["docFiles", "photoFiles"].includes(record.module))) {
            const fileOrigName = _.get(record, "detail.file.originalname", '');
            msg = folderPath ? folderPath + "/" + fileOrigName : fileOrigName;
        }
        return <span> {msg} </span>;
    }
    return value;
};

const columns = [
    {
        title: 'Creation Date',
        dataIndex: 'creationDate',
        key: 'creationDate',
        sorter: (a, b) => {
            return a.creationDate.localeCompare(b.creationDate)
        },
    },
    {
        title: 'User Name',
        dataIndex: 'username',
        key: 'username',
        sorter: (a, b) => {
            return a.username.localeCompare(b.username, 'en', {
                caseFirst: false,
                sensitivity: 'base',
                numeric: true,
                ignorePunctuation: true
            })
        },
    },
    {
        title: 'IP Address',
        dataIndex: 'clientIP',
        key: 'clientIP',
        /*sorter: (a, b) => { return a.clientIP.localeCompare(b.clientIP)},*/
    },
    {
        title: 'Module',
        dataIndex: 'module',
        key: 'module',
        sorter: (a, b) => {
            return a.module.localeCompare(b.module)
        },
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        sorter: (a, b) => {
            return a.action.localeCompare(b.action)
        },
    },
    {
        title: 'Document Targeted',
        dataIndex: 'detail',
        key: 'detail',
        render: docTarget,
    },

];

/*

const filterColumns = {
    onChange: (pagination, filters, sorter) => {
        console.log('params', pagination, filters, sorter);
    }


};
*/

class ActivityContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTableInternal: [],
            loading: true,
            selectedDocumentKey: '',
            selectedDocuments: [],
            selectedTab: '1',

        }
    }


    componentDidMount = () => {
        monitorService.getActivities().then((access) => {
            this.setState(() => {
                return {dataTableInternal: access.rows, loading: false};
                console.log(access.rows);
            })
        });
    };

    handleDownload = (event) => {
        let period = event.key;
        console.log('download event.key', event.key);
        if (this.state.selectedTab === '1') {
            console.log(this.state.selectedTab);
            if (period) {
                fileDownloadService.download('/api/v1/monitor/activities/download/' + period, 'activitiesLast' + period + '.csv');
            }
        }
        else if (this.state.selectedTab === '2') {
            console.log(this.state.selectedTab);
            if (period) {
                fileDownloadService.download('/api/v1/monitor/publicActivities/download/' + period, 'activitiesLast' + period + '.csv');
            }
        }
    };

    render() {

        const menu = (
            <Menu>
                <Menu.Item key="7d" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 7 days
                </Menu.Item>
                <Menu.Item key="30d" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 30 days
                </Menu.Item>
                <Menu.Item key="6m" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 6 months
                </Menu.Item>
                <Menu.Item key="1y" onClick={this.handleDownload}>
                    <Icon type="download"/>
                    Last 1 year
                </Menu.Item>
            </Menu>
        )

        const pagination = {
            total: this.state.count,
            pageSize: 14,
            pageSizeOptions: ['14'],
        }
        const toolBarItems = [
            {
                title: 'Download',
                icon: 'download',
                type: 'dropdown-button',
                menu: menu,
                trigger: ['click']
            }
        ]

        return (
            <div>
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        <Breadcrumb.Item>Activities</Breadcrumb.Item>
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={value => {
                                    this.setState(
                                        {
                                            searchString: value,
                                        },
                                    )
                                }}
                                style={{width: 330}}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>

                <Tabs defaultActiveKey="1" style={{boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)'}}
                      onChange={(tabSelected) => {
                          this.setState({
                              selectedTab: tabSelected,
                          });
                          console.log('value event onChange', tabSelected);
                      }}>
                    <TabPane tab={<span> <Icon type="monitor"/> Internal Activities </span>} key="1">
                        <Spin spinning={this.state.loading} delay={500}>
                            <Table
                                dataSource={this.state.dataTableInternal}
                                columns={columns}
                                pagination={pagination}
                            />
                        </Spin>
                    </TabPane>
                    <TabPane tab={<span> <Icon type="monitor"/> Public Activities </span>} key="2">
                        <ActivityPublicContainer/>
                    </TabPane>
                </Tabs>

            </div>
        )
    }
}

export default ActivityContainer